var _rect, _title, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      enableBackground: "new 0 0 217.855 217.855"
    },
    xmlSpace: "preserve",
    width: 217.855,
    height: 217.855,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.2884347515106,54.09347825050354 L165.93543475151063,2.73947825050354 C164.52943475151062,1.33347825050354 162.62143475151063,0.54347825050354 160.63243475151063,0.54347825050354 c-1.9889999999999999,0 -3.8970000000000002,0.79 -5.303,2.196 L5.43943475151062,152.62947825050355 c-1.35,1.352 -2.135,3.166 -2.193,5.075 l-1.6110000000000002,52.966 c-0.06300000000000001,2.067 0.7310000000000001,4.069 2.193,5.532 c1.409,1.408 3.317,2.196 5.303,2.196 c0.07600000000000001,0 0.15200000000000002,-0.0010000000000000002 0.22900000000000004,-0.004000000000000001 l52.964,-1.613 c1.909,-0.05800000000000001 3.724,-0.8420000000000001 5.075,-2.192 l149.89,-149.889 C220.2174347515106,61.77147825050354 220.2174347515106,57.02247825050354 217.2884347515106,54.09347825050354 zM58.89443475151062,201.87947825050355 l-42.024,1.28 l1.279,-42.026 l91.124,-91.125 l40.75,40.743 L58.89443475151062,201.87947825050355 zM160.63043475151062,100.14547825050354 l-40.751,-40.742 l40.752,-40.753 l40.746,40.747 L160.63043475151062,100.14547825050354 z",
    id: "svg_1",
    className: "selected",
    fill: "#ffffff",
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.535b1cb8e97b51cdafab4d705df1f23d.svg";
export { ForwardRef as ReactComponent };